import React, { useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import './Deadline.scss';

import BorderImage from '../assets/images/border.js';
import LastDay from '../assets/images/lastDay.js';
import DeadlineHeader from '../assets/images/deadline_header.js';
import BigDate from '../assets/images/bigDate.js';
import Loading from '../assets/images/loading.js';
import Header from '../components/Header.js';
import Line from '../assets/images/line.js';
import Metrics from '../assets/images/metrics.js';
import Star from '../assets/images/star.js';
import The from '../assets/images/the.js';
import DeathClock from '../assets/images/death_clock.js';
import Telegram from '../assets/images/telegram.js';
import Twitter from '../assets/images/twitter.js';

import Heart from '../components/death_reasons_slides/heart.js';
import Diabet from '../components/death_reasons_slides/diabet.js';
import Cancer from '../components/death_reasons_slides/cancer.js';
import Mental from '../components/death_reasons_slides/mental.js';
import Sleep from '../components/death_reasons_slides/sleep.js';
import Pneumonia from '../components/death_reasons_slides/pneumonia.js';
import MenCancer from '../components/death_reasons_slides/men_cancer.js';
import WomenCancer from '../components/death_reasons_slides/women_cancer.js';
import Stress from '../components/death_reasons_slides/stress.js';
import Stroke from '../components/death_reasons_slides/stroke.js';

import { setImageName } from '../store/userSlice';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cards';
import { generateAndUploadImage } from '../utils/imageGenerator';
import SlideActions from '../components/SlideActions';
import { handlePayment } from '../utils/payment';

const deathReasonComponents = {
  'cancer': Cancer,
  'mentalHealth': Mental,
  'stress': Stress,
  'sleepDisorders': Sleep,
  'cardiology': Heart,
  'cardiovascular': Heart,
  'diabetes': Diabet,
  'pneumonia': Pneumonia,
  'prostateCancer': MenCancer,
  'breastCancer': WomenCancer,
  'brainHemorrhage': Stroke,
};

const DeadLine = () => {
  const { userData, initData, advices, deathReasons, language, showPaidLoadingScreen, isPaid } = useSelector(state => state.user);
  const [isLoading, setIsLoading] = useState(true);
  const [showLoadingScreen, setShowLoadingScreen] = useState(true);
  const contentRef = useRef(null);
  const [imageUrl, setImageUrl] = useState(null);
  const dispatch = useDispatch();
  const swiperRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);

  console.log('🔄 optimisticAge:', userData?.optimistic_age);

  useEffect(() => {
    const timer = setTimeout(() => {
      console.log('🔄 4 секунды прошли');
      setShowLoadingScreen(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (userData && userData.death_date && !imageUrl) {
      generateAndUploadImage({
        contentRef,
        userData,
        initData,
        setImageUrl,
        setIsLoading,
        dispatch,
        setImageName
      });
    }
  }, [userData]);

  useEffect(() => {
    if (showPopup) {
      const timer = setTimeout(() => {
        setShowPopup(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showPopup]);

  const formatDate = (dateString) => {
    if (!dateString) return language === 'RUS' ? 'Дата не определена' : 'Date not defined';
    
    const [day, month, year] = dateString.split('.');
    const months = language === 'RUS' ? [
      'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
      'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ] : [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    const monthName = months[parseInt(month) - 1];
    if (!monthName) return language === 'RUS' ? 'Некорректная дата' : 'Invalid date';
    
    return `${day} ${monthName.toUpperCase()} ${year}`;
  };

  const formattedDeathDate = formatDate(userData?.death_date);
  const deathAge = userData?.death_date && userData?.current_age
    ? parseInt(userData.death_date.split('.')[2]) - new Date().getFullYear() + parseInt(userData.current_age)
    : null;
  const optimisticAge = userData?.optimistic_age || null;

  console.log('🔄 deathAge:', deathAge);
  console.log('🔄 optimisticAge:', optimisticAge);

  const shareToStory = () => {
    if (!imageUrl) {
      window.Telegram.WebApp.showPopup({
        title: 'Ошибка',
        message: 'Изображение еще не готово. Пожалуйста, подождите.',
        buttons: [{ type: "ok" }]
      });
      return;
    }

    if (window.Telegram?.WebApp?.shareToStory) {
      window.Telegram.WebApp.shareToStory(imageUrl, {
        text: language === 'RUS' ? 'Узнай дату своей смерти' : 'Find out your death date',
        background_color: '#000000',
        widget_link: {
          url: 'https://t.me/polkapad_bot',
          name: language === 'RUS' ? 'Узнать дату своей смерти' : 'Find out your death date',
        }
      });
    } else {
      console.error('Sharing to story is not supported');
    }
  };

  const years = (date) => {
    const lastSymbol = date.toString().at(-1);

    return lastSymbol === '1' ? 'год' : lastSymbol === '2' || lastSymbol === '3' || lastSymbol === '4' ? 'года' : 'лет';
    
  }

  const goToNextSlide = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const goToPrevSlide = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handlePaymentClick = () => {
    handlePayment({ dispatch });
  };

  return (
    <>
      {/* Первый загрузочный экран (до оплаты) */}
      {(isLoading || showLoadingScreen || !userData.death_date) && !isPaid && (
        <div className="loading-deadline">
          <div className="loading-deadline__text-container">
            <div className="loading-deadline__text-1">
              {language === 'RUS' ? 'Обрабатываем ваши ответы' : 'Processing your answers'}
            </div>
            <div className="loading-deadline__text-2">
              {language === 'RUS' ? 'Вычисляем дату смерти' : 'Calculating death date'}
            </div>
          </div>
          <Loading />
          <div className="loading-deadline__text-container">
            <div className="loading-deadline__text-3">
              {language === 'RUS' ? '1217 научных исследований' : '1,217 scientific studies'}
            </div>
            <div className="loading-deadline__text-4">
              {language === 'RUS' ? '50 млн+ участников' : '50M+ participants'}
            </div>
          </div>
        </div>
      )}

      {/* Второй загрузочный экран (после оплаты) */}
      {showPaidLoadingScreen && (
        <div className="loading-deadline loading-deadline-paid">
          <div className="loading-deadline__text-container">
            <div className="loading-deadline__text-1">
              {language === 'RUS' ? 'Вычисляем причины смерти' : 'Calculating death reasons'}
            </div>
            <div className="loading-deadline__text-2">
              {language === 'RUS' ? 'Готовим ваши персональные рекомендации' : 'Preparing your personalized recommendations'}
            </div>
          </div>
          <Loading />
          <div className="loading-deadline__text-container">
            <div className="loading-deadline__text-3">
              {language === 'RUS' ? 'Более 10 млн ГБ данных' : 'Over 10M GB of data'}
            </div>
            <div className="loading-deadline__text-4">
              {language === 'RUS' ? '15+ лет исследований' : '15+ years of research'}
            </div>
          </div>
        </div>
      )}

      <div className="deadline">
        <Header />
        <Swiper
          ref={swiperRef}
          className="deadline__slides"
          spaceBetween={12}
          slidesPerView={1}
          centeredSlides={true}
          grabCursor={true}
          touchEventsTarget="container"
          loop={false}
          speed={300}
          resistance={true}
          // resistanceRatio={0.85}
          onInit={(swiper) => {
            // Принудительно обновляем свайпер после инициализации
            setTimeout(() => {
              swiper.update();
            }, 0);
          }}
        >
          <SwiperSlide ref={contentRef} className='deadline__slide1'>
            <div className="deadline__space"></div>
            <div className="deadline__content">
              <BorderImage />
              {language === 'ENG' ? <The /> : ''}
              {language === 'ENG' ? <DeadlineHeader /> : <LastDay />}
              <BigDate />
              <div className="deadline__date">
                <div className="deadline__death-date">{formattedDeathDate}</div>
                <div className="deadline__name">
                  {language === 'RUS' 
                    ? <>{userData?.name}, с вашими<br/>текущими<br/>привычками, Вы<br/>умрете в возрасте<br/>{deathAge ? `${deathAge} ${language === 'ENG' ? 'years' : years(deathAge)}` : ''}</>
                    : <>{userData?.name}, with your<br/>current habits, you<br/>will die at the age of<br/>{deathAge ? `${deathAge} ${language === 'ENG' ? 'years' : years(deathAge)}` : ''}</>
                  }
                </div>
              </div>
            </div>
            <SlideActions 
              language={language}
              onShare={shareToStory} 
              onNext={goToNextSlide}
              nextButtonText={language === 'RUS' ? 'Узнать Почему я умру ->' : 'Find out why I will die ->'}
              imageUrl={imageUrl}
            />
          </SwiperSlide>

          {deathReasons?.map((reason, index) => {
            console.log('🎯 Рендерим причину:', reason);
            const [type] = reason.split(':');
            const Component = deathReasonComponents[type];
            
            return Component ? (
              <SwiperSlide key={`${type}-${index}`}>
                <Component />
                <SlideActions 
                  language={language}
                  onPrev={() => {
                    if (swiperRef.current && swiperRef.current.swiper) {
                      swiperRef.current.swiper.slidePrev();
                    }
                  }}
                  onNext={goToNextSlide}
                  imageUrl={imageUrl}
                />
              </SwiperSlide>
            ) : (
              console.error('❌ Не найден компонент для типа:', type)
            );
          })}

          <SwiperSlide>
            <div className="deadline__slide2">
              <BorderImage />
              {!deathReasons && (
                <>
                  {language === 'ENG' && <The />}
                  {language === 'ENG' ? <DeadlineHeader /> : <LastDay />}
                  <Line />
                  <Metrics />

                  <div className="deadline__death-age">
                    {deathAge}
                    {/* 75 */}
                  </div>
                  <div className="deadline__optimistic-age">
                    {optimisticAge}
                    {/* 95 */}
                  </div>
                </>
              )}
              {deathReasons
                ? <div className='deadline__deathReasons'>
                    <h2>{language === 'RUS' ? 'Как перенести дедлайн?' : 'How to Move the deadline?'}</h2>
                    <ul className='deadline__purchase-list'>
                      {advices.map((advice) => <li>{advice[language === 'RUS' ? 0 : 1]}</li>)}
                    </ul>
                  </div>
                : ''
              }
              <div className="deadline__purchase">
                <ul>
                  {!deathReasons && <li>{language === 'RUS' ? 'Узнай вероятные причины твоей смерти' : 'Find out the probable causes of your death'}</li>}
                  {!deathReasons && <li>{language === 'RUS' ? `Продли свою жизнь на ${optimisticAge - deathAge} ${years(optimisticAge - deathAge)} благодаря здоровым привычкам:` : `Extend your life by ${optimisticAge - deathAge} years thanks to healthy habits:`}</li>}
                </ul>
                {!deathReasons && <ul className='deadline__hidden'>
                  <li>{language === 'RUS' ? 'Чтобы увидеть рекомендации - необходимо активировать твоего ИИ-агента по долголетию' : 'In order to see recommendations, you need to activate your AI agent for longevity'}</li>
                  <li>{language === 'RUS' ? 'Он расскажет тебе как продлить твою жизнь' : 'He will tell you how to extend your life'}</li>
                  <li>{language === 'RUS' ? 'Дерзай' : 'Go for it'}</li>
                </ul>}
                
              </div>
              <button 
                className="deadline__footer" 
                onClick={() => {
                  if (!deathReasons) {
                    goToPrevSlide();
                  } else {
                    goToNextSlide();
                  }
                }}
              >
                {!deathReasons ? (language === 'RUS' ? 'Назад' : 'Back') : (language === 'RUS' ? 'Запустить ИИ-Агента' : 'Run AI Agent')}
              </button>
              {!deathReasons && <button 
                onClick={handlePaymentClick}
                className="deadline__footer"
              >
                <Star />
                {language === 'RUS' ? 'Узнать почему я умру' : 'Find out why I will die'}
              </button>}
              {deathReasons && <button 
                onClick={() => {
                  const text = advices.map(advice => advice[language === 'RUS' ? 0 : 1]).join('\n');
                  navigator.clipboard.writeText(text);
                  setShowPopup(true);
                }}
                className="deadline__footer"
              >
                <AnimatePresence mode="wait">
                  {showPopup && (
                    <motion.div 
                      className="popup"
                      initial={{ opacity: 0, top: "-30px" }}
                      animate={{ opacity: 0.8, top: "-49px" }}
                      exit={{ opacity: 0, top: "-30px" }}
                      transition={{ 
                        duration: 0.2,
                        ease: "easeInOut"
                      }}
                    >
                      {language === 'RUS' ? 'Скопировано в буфер' : 'Copied to clipboard'}
                    </motion.div>
                  )}
                </AnimatePresence>
                {language === 'RUS' ? 'Сохранить' : 'Save'}
              </button>}
              
            </div>
          </SwiperSlide>

          {deathReasons && (
              <SwiperSlide className='deadline__slide6wrapper'>
                <div className="deadline__slide6">
                  <BorderImage />
                  <DeadlineHeader />
                  <DeathClock />

                  <p
                    className='deadline__slide6-text'
                    dangerouslySetInnerHTML={{
                      __html: language === 'RUS'
                        ? 'Поздравляем с покупкой!<br/><br/><strong>Скоро здесь будет ваш персональный ИИ-Агент по долголетию.</strong><br/><br/>Благодарим за поддержку проекта Deadline ML. Следите за обновлениями в нашем сообществе.'
                        : 'Congratulations on your purchase!<br/><br/><strong>Your personal AI longevity agent will be here soon.</strong><br/><br/>Thank you for supporting the Deadline ML project. Stay tuned for updates in our community.'
                    }}
                  />

                  <div className="deadline__slide6-socials">
                      <a href="https://t.me/deadlineml" target="_blank" rel="noopener noreferrer">
                        <Telegram />
                      </a>
                      <a href="https://x.com/deadlineml" target="_blank" rel="noopener noreferrer">
                        <Twitter />
                      </a>
                  </div>
              </div>

              <button 
                className="deadline__footer" 
                onClick={() => {
                  goToPrevSlide();
                }}
              >{language === 'RUS' ? 'Назад' : 'Back'}</button>
              <button 
                className="deadline__footer" 
                onClick={() => {
                  swiperRef.current.swiper.slideTo(0);
                }}
              >{language === 'RUS' ? 'Посмотреть мой дедлайн' : 'Check my Deadline'}</button>
            </SwiperSlide>
            )
          }
        </Swiper>
      </div>
    </>
  );
};

export default DeadLine;
